<template>
  <v-app>
    <!-- Full-screen loader — shows itself only after 300ms of loading. -->
    <AliceLoader :model-value="isLoading" />
    <v-app-bar
      v-if="$route.meta.nav"
      flat
      color="black"
      class="d-flex align-center"
    >
      <!-- <v-btn @click="test">test</v-btn> -->
      <!-- <template v-slot:prepend>
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
      </template> -->

      <v-app-bar-title style="margin-left: 10px">
        <div class="d-flex pl-4 align-center justify-space-between">
          <v-img
            max-width="60"
            :src="require('@/assets/logos/logo-white.svg')"
          ></v-img>
          <div class="d-flex" style="gap: 25px">
            <!-- <v-btn @click="testWebhook">Test Webhook</v-btn> -->
            <v-btn
              @click="$router.push('/profile')"
              style="text-transform: none"
              variant="text"
              >My profile</v-btn
            >
            <v-btn
              class="mr-4"
              style="text-transform: none"
              @click="this.$store.dispatch('signOut')"
              >Sign Out</v-btn
            >
          </div>
        </div>
      </v-app-bar-title>
    </v-app-bar>
    <v-navigation-drawer
      :permanent="true"
      expand-on-hover
      rail
      v-if="$route.meta.nav"
    >
      <v-list nav>
        <v-list-item
          height="64"
          prepend-icon="mdi-folder"
          to="/projects"
          link
          title="Projects"
        ></v-list-item>
        <v-list-group
          prepend-icon="mdi-account-group"
          no-action
          v-if="user?.uid === '5PYQUTe0v7PYjUjjd79DeLXUff13'"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              height="64"
              link
              title="HR"
            ></v-list-item>
          </template>
          <v-list-item
            prepend-icon="mdi-account-group"
            to="/hr/people"
            link
            title="People"
          ></v-list-item>
        </v-list-group>
        <v-list-group prepend-icon="mdi-tools" no-action>
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              height="64"
              link
              title="Tools"
            ></v-list-item>
          </template>
          <v-list-item
            prepend-icon="mdi-palette"
            to="/tools/color-pallette"
            link
            title="Color Palette"
          ></v-list-item>
        </v-list-group>
        <v-list-group prepend-icon="mdi-currency-usd" value="true" no-action>
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              height="64"
              link
              title="Sales"
            ></v-list-item>
          </template>
          <v-list-item
            prepend-icon="mdi-calculator-variant"
            to="/sales"
            link
            title="Pricing Calculator"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-chart-bar"
            to="/sales/benchmark"
            link
            title="Benchmark"
          ></v-list-item>
        </v-list-group>
        <v-list-item
          v-if="
            user?.uid === '5PYQUTe0v7PYjUjjd79DeLXUff13' ||
            user?.uid === 'qw85RHssYucL2vZMM1UoaiBiRWf1'
          "
          height="64"
          prepend-icon="mdi-shield-crown"
          to="/admin"
          link
          title="Admin"
        ></v-list-item>
      </v-list>
      <template #append>
        <v-list nav>
          <v-list-item
            height="64"
            prepend-icon="mdi-lightbulb-outline"
            to="/requests"
            link
            title="Feature requests"
          ></v-list-item>
          <v-list-item
            height="64"
            prepend-icon="mdi-book-open-variant"
            to="/changelog"
            link
            title="Changelog"
          ></v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>

    <!-- Guest onboarding wizard — renders itself only for guests when open. -->
    <GuestIntroWizard />
    <!-- "What's new" changelog dialog — colleagues only, opens after login
         when there are unseen changelog entries. -->
    <WhatsNewDialog />
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import GuestIntroWizard from "@/components/GuestIntroWizard.vue";
import WhatsNewDialog from "@/components/WhatsNewDialog.vue";
import AliceLoader from "@/components/alice/AliceLoader.vue";

export default {
  components: { GuestIntroWizard, WhatsNewDialog, AliceLoader },
  computed: {
    ...mapState({
      projects: (state) => state.projects,
      project: (state) => state.project,
      isLoading: (state) => state.loading,
      user: (state) => state.user,
    }),
  },
  methods: {
    testWebhook() {
      const testWebhook = httpsCallable(functions, "testWebhook");
      testWebhook({}).then((result) => {
        console.log(result);
      });
    },
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.subtitle {
  font-size: 10pt;
  max-width: 500px;
  text-align: start;
}

/* ===== Alice popover menus (v-menu + .alice-menu-list) =====
   The menu content is teleported to <body>, so these overrides must be
   global (not scoped). Replaces Vuetify's rounded/elevated default with the
   Alice design system: square corners, a hairline border, a crisp shadow and
   the UI type scale. */
.v-overlay__content:has(> .alice-menu-list) {
  border-radius: 0;
  box-shadow: none;
}
.alice-menu-list.v-list {
  padding: 4px;
  border: 1px solid var(--border-hairline);
  border-radius: 0;
  background: var(--vp-white);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
}
.alice-menu-list .v-list-item {
  min-height: 0;
  padding: 9px 14px;
  border-radius: 0;
  transition: background var(--dur-fast) var(--ease-hover);
}
.alice-menu-list .v-list-item__overlay {
  border-radius: 0;
}
/* Disable Vuetify's hover/active tint overlay; use an Alice background instead. */
.alice-menu-list .v-list-item:hover .v-list-item__overlay,
.alice-menu-list .v-list-item--active .v-list-item__overlay {
  opacity: 0;
}
.alice-menu-list .v-list-item:hover:not(.v-list-item--disabled) {
  background: var(--bg-muted);
}
.alice-menu-list .v-list-item-title {
  font-family: var(--font-ui);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0;
  color: var(--vp-black);
}
.alice-menu-list .v-list-item--disabled .v-list-item-title {
  color: var(--fg-3);
}
</style>
